/**
 * Bundler Variant Sync – DillySocks
 * ──────────────────────────────────
 * Synchronisiert die Größenauswahl des Hauptprodukts mit allen
 * Bundle-Produkt-Dropdowns der Bundler App.
 *
 * Theme-Struktur (DillySocks):
 *   Hauptprodukt-Variante: <select class="product-variants" name="id">
 *     Option-Text enthält Preis: "41-46 - 16.90 CHF"
 *     Option-Value = Shopify Variant ID
 *
 *   Bundler-Dropdowns: <select class="bndlr-select-variant id_XXXXX">
 *     Option-Text = Varianten-Titel: "41-46" (oder "41-46 - 16.90 CHF")
 *     Option-Value = Shopify Variant ID
 *
 * Logik:
 *   1. Aus dem gewählten Hauptprodukt-Select den Größen-String extrahieren
 *      (alles vor dem " - " Trennzeichen, z.B. "41-46")
 *   2. Alle Bundle-Selects durchgehen und die Option finden, deren Text
 *      mit dem gleichen Größen-String beginnt
 *   3. Change-Event dispatchen damit Bundler Preise aktualisiert
 *
 * Edge Cases:
 *   - Produkte mit weniger Varianten (z.B. Doggy Dog nur 36-40 / 41-46):
 *     Wenn die gewählte Größe nicht existiert, wird die nächstbeste gewählt
 *   - Bundle-Dropdown-Text kann mit oder ohne Preis sein
 *
 * Einbindung: Als <script> in theme.liquid vor </body> oder als
 *             Custom Liquid Block auf der Produktseite
 */
(function () {
  'use strict';
  console.log('bundler-variant-sync-dillysocks.js loaded');

  /* ── Config ─────────────────────────────────────────────────── */

  var MAIN_SELECT_SELECTOR = 'select.product-variants';
  var BUNDLE_SELECT_SELECTOR = 'select.bndlr-select-variant';
  var PRICE_SEPARATOR = ' - '; // Trennzeichen zwischen Größe und Preis im Select-Text
  var variantChangeListenerBound = false;
  var alpineVariantListenerBound = false;

  /* ── Helpers ────────────────────────────────────────────────── */

  /**
   * Extrahiert den Größen-String aus dem Select-Option-Text.
   * "41-46 - 16.90 CHF" → "41-46"
   * "41-46"              → "41-46"
   */
  function extractSize(optionText) {
    if (!optionText) return '';
    var idx = optionText.indexOf(PRICE_SEPARATOR);
    return (idx > -1 ? optionText.substring(0, idx) : optionText).trim();
  }

  /**
   * Liefert den relevanten Hauptprodukt-Select möglichst im selben
   * Produktkontext wie das Bundler-Widget (falls vorhanden).
   */
  function getRelevantMainSelect() {
    var firstBundleSelect = document.querySelector(BUNDLE_SELECT_SELECTOR);
    if (firstBundleSelect) {
      var productContent = firstBundleSelect.closest('.product-content');
      if (productContent) {
        var scopedMainSelect = productContent.querySelector(MAIN_SELECT_SELECTOR);
        if (scopedMainSelect) return scopedMainSelect;
      }
    }
    return document.querySelector(MAIN_SELECT_SELECTOR);
  }

  /**
   * Gibt den Größen-String der aktuell gewählten Hauptprodukt-Variante zurück.
   */
  function getSelectedSize() {
    var mainSelect = getRelevantMainSelect();
    if (!mainSelect || mainSelect.selectedIndex < 0) return null;
    return extractSize(mainSelect.options[mainSelect.selectedIndex].text);
  }

  /**
   * Definierte Größen-Reihenfolge für Nearest-Match-Fallback.
   */
  var SIZE_ORDER = ['36-40', '41-46', '46-50'];

  /**
   * Findet die nächstbeste verfügbare Größe, wenn die gewünschte
   * im Bundle-Produkt nicht existiert.
   */
  function findNearestSize(targetSize, availableSizes) {
    var targetIdx = SIZE_ORDER.indexOf(targetSize);
    if (targetIdx === -1) return availableSizes[0] || null;

    // Erst gleiche, dann aufsteigend/absteigend nach Distanz suchen
    var sorted = availableSizes.slice().sort(function (a, b) {
      var distA = Math.abs(SIZE_ORDER.indexOf(a) - targetIdx);
      var distB = Math.abs(SIZE_ORDER.indexOf(b) - targetIdx);
      return distA - distB;
    });

    return sorted[0] || null;
  }

  /**
   * Synchronisiert alle Bundle-Selects auf die übergebene Größe.
   */
  function syncBundleSelects(targetSize) {
    if (!targetSize) return;

    var bundleSelects = document.querySelectorAll(BUNDLE_SELECT_SELECTOR);
    if (bundleSelects.length === 0) return;

    bundleSelects.forEach(function (select) {
      var matched = false;
      var availableSizes = [];

      // 1. Exakter Match
      for (var i = 0; i < select.options.length; i++) {
        var optSize = extractSize(select.options[i].text);
        availableSizes.push(optSize);

        if (optSize === targetSize) {
          if (select.value !== select.options[i].value) {
            select.value = select.options[i].value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          matched = true;
          break;
        }
      }

      // 2. Fallback: Nearest Match (z.B. Produkt hat kein 46-50)
      if (!matched && availableSizes.length > 0) {
        var nearest = findNearestSize(targetSize, availableSizes);
        if (nearest) {
          for (var j = 0; j < select.options.length; j++) {
            if (extractSize(select.options[j].text) === nearest) {
              if (select.value !== select.options[j].value) {
                select.value = select.options[j].value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
              break;
            }
          }
        }
      }
    });
  }

  /* ── Event Listener ─────────────────────────────────────────── */

  /**
   * Delegierter Listener für ALLE relevanten Hauptprodukt-Selects.
   * Wichtig, weil im Theme mehrere add-to-cart Formen existieren können
   * und das "falsche" Select sonst gebunden wird.
   */
  function bindVariantChangeListener() {
    if (variantChangeListenerBound) return;
    variantChangeListenerBound = true;

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches(MAIN_SELECT_SELECTOR)) return;
      if (target.selectedIndex < 0) return;

      // Kurzes Delay damit das Theme seine eigenen Listener
      // zuerst abarbeiten kann (URL-Update, Preis, Bild etc.)
      setTimeout(function () {
        var size = extractSize(target.options[target.selectedIndex].text);
        syncBundleSelects(size);
      }, 50);
    });
  }

  /**
   * Zusätzlicher Listener für die Alpine-Variantenauswahl.
   * Im Theme wird beim Klick auf eine Größe ein "setvariantevent"
   * mit { message: { title: "41-46", ... } } dispatcht.
   */
  function bindAlpineVariantListener() {
    if (alpineVariantListenerBound) return;
    alpineVariantListenerBound = true;

    window.addEventListener('setvariantevent', function (event) {
      var detail = event && event.detail ? event.detail : null;
      var variant = detail && detail.message ? detail.message : null;
      if (!variant || !variant.title) return;
      syncBundleSelects(extractSize(variant.title));
    });
  }

  /* ── Init ───────────────────────────────────────────────────── */

  /**
   * Initialer Sync + Listener-Setup.
   * Wird aufgerufen sobald das Bundler-Widget gerendert ist.
   */
  function init() {
    // Initialer Sync: Bundle-Selects auf aktuell gewählte Größe setzen
    var size = getSelectedSize();
    syncBundleSelects(size);

    // Listener für zukünftige Änderungen
    bindVariantChangeListener();
    bindAlpineVariantListener();
  }

  /* ── Bootstrap ──────────────────────────────────────────────── */

  // 1. Event-basiert: Bundler feuert dieses Event wenn das Widget rendert
  document.addEventListener('bundler:bundle_widget_created', function () {
    setTimeout(init, 300);
  });

  // Optionales Bundler-Globalevent laut Doku
  document.addEventListener('bundler:loaded', function () {
    setTimeout(init, 300);
  });

  // 2. Fallback: Widget existiert schon (Script lädt nach Widget)
  if (document.querySelectorAll(BUNDLE_SELECT_SELECTOR).length > 0) {
    init();
  }

  // 3. MutationObserver als letzter Fallback
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var addedNodes = mutations[i].addedNodes;
      for (var j = 0; j < addedNodes.length; j++) {
        var node = addedNodes[j];
        if (node.nodeType === 1 && node.querySelector && node.querySelector(BUNDLE_SELECT_SELECTOR)) {
          observer.disconnect();
          setTimeout(init, 300);
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Observer nach 15s aufräumen falls nie getriggert
  setTimeout(function () {
    observer.disconnect();
  }, 15000);

})();
